// Nhóm "Điểm danh": lịch thưởng 7 ngày (kiểu app), mốc chuỗi dài, giờ nhắc.
import { Button, InputNumber, theme } from "antd";
import { faCalendarCheck, faGift, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Field, GroupCard, NumField } from "./xu-config-fields";
import { fmtNum } from "./xu-format-helpers";

/** Ô "lịch điểm danh": ngày cuối vòng nổi bật như trong app. */
function DayTile({ index, value, last, onChange }) {
    const { token } = theme.useToken();
    return (
        <div className="rounded-xl border p-2 text-center" style={{ borderColor: last ? token.colorWarning : token.colorBorderSecondary, background: last ? token.colorWarningBg : token.colorBgContainer }}>
            <div className="text-xs mb-1 font-medium" style={{ color: last ? token.colorWarning : token.colorTextSecondary }}>
                {last && <FontAwesomeIcon icon={faGift} className="mr-1" />}Ngày {index + 1}
            </div>
            <InputNumber size="small" min={0} max={100000} value={value} controls={false} style={{ width: "100%" }} onChange={(v) => onChange(v ?? 0)} />
            <div className="text-[11px] text-gray-400 mt-1">Xu</div>
        </div>
    );
}

export default function XuConfigCheckinCard({ config, set, onReset }) {
    const setReward = (i, v) => set({ checkinRewards: config.checkinRewards.map((x, idx) => (idx === i ? v : x)) });
    const setMilestone = (i, patch) => set({ milestones: config.milestones.map((m, idx) => (idx === i ? { ...m, ...patch } : m)) });
    const cycle = config.checkinRewards.reduce((s, v) => s + (Number(v) || 0), 0);
    return (
        <GroupCard
            id="xu-sec-checkin" icon={faCalendarCheck} tone="text-emerald-500"
            title="Điểm danh"
            description="Mỗi ngày người dùng bấm điểm danh một lần để nhận Xu. Chuỗi 7 ngày lặp lại; bỏ lỡ một ngày thì chuỗi về ngày 1."
            onReset={onReset}
        >
            <Field label="Xu thưởng từng ngày trong vòng 7 ngày" hint="Đây là số Xu GỐC; hạng càng cao nhận càng nhiều (xem nhóm Hạng).">
                <div className="grid grid-cols-4 sm:grid-cols-7 gap-2 max-w-3xl">
                    {config.checkinRewards.map((v, i) => (
                        <DayTile key={i} index={i} value={v} last={i === config.checkinRewards.length - 1} onChange={(x) => setReward(i, x)} />
                    ))}
                </div>
                <div className="mt-2 text-sm">Điểm danh đủ 1 vòng nhận <b>{fmtNum(cycle)} Xu</b> (gốc, chưa nhân hạng).</div>
            </Field>
            <Field label="Thưởng thêm khi giữ chuỗi dài" hint="Tính theo số ngày điểm danh thật liên tiếp. Mốc có huy hiệu sẽ tặng kèm huy hiệu Chuyên cần." example="Mốc 30 ngày, thưởng 300 Xu">
                <div className="space-y-2">
                    {config.milestones.map((m, i) => (
                        <div key={i} className="flex flex-wrap items-center gap-2">
                            <span className="text-gray-500 w-10">Sau</span>
                            <InputNumber min={1} max={3650} value={m.day} style={{ width: 150 }} addonAfter="ngày" onChange={(v) => setMilestone(i, { day: v || 1 })} />
                            <span className="text-gray-500">thưởng</span>
                            <InputNumber min={0} max={100000} value={m.xu} style={{ width: 140 }} addonAfter="Xu" onChange={(v) => setMilestone(i, { xu: v || 0 })} />
                            {m.badge && <span className="text-xs text-amber-600">kèm huy hiệu</span>}
                            <Button danger type="text" size="small" icon={<FontAwesomeIcon icon={faTrash} />} onClick={() => set({ milestones: config.milestones.filter((_, idx) => idx !== i) })} />
                        </div>
                    ))}
                    <Button size="small" onClick={() => set({ milestones: [...config.milestones, { day: 7, xu: 100 }] })}>+ Thêm mốc</Button>
                </div>
            </Field>
            <div className="flex flex-wrap gap-x-8">
                <NumField label="Giờ nhắc điểm danh" unit="giờ" min={0} max={23} value={config.reminder.hour}
                    onChange={(v) => set({ reminder: { ...config.reminder, hour: v } })} hint="Giờ Việt Nam, 0–23. Ví dụ 20 = 8 giờ tối." />
                <NumField label="Chỉ nhắc người có chuỗi từ" unit="ngày" min={1} value={config.reminder.minStreak}
                    onChange={(v) => set({ reminder: { ...config.reminder, minStreak: v } })} hint="Chuỗi ngắn hơn sẽ không bị nhắc (tránh làm phiền)." />
            </div>
        </GroupCard>
    );
}
